module.exports = __webpack_public_path__ + "media/images/common/defaults/icon-a19b7c7607fdd5428142a6a53b9f43ff.png";